
    //missing number find algorithem
    const missingNumberFunc= (array:number[]) =>{
        if(array.length === 0){
          return 1
        }else{
          const segArray = array.filter((a) => a > 0);
          for (let i = 0; i < segArray.length; i++) {
            const value = Math.abs(segArray[i]);
            if (value <= segArray.length && segArray[value - 1] > 0) {
              segArray[value - 1] *= -1;
            }
          }
          for (let i = 0; i < segArray.length; i++) {
            if (segArray[i] > 0) {
              return i + 1;
            }
          }
          return segArray.length + 1;
        }
      }
export default missingNumberFunc;
